import { z } from "zod/v4";

import { PluginBuiltBySchema_2024_05_05 } from "./built-by/2024-05-05";
import { PluginExclusionGroupSchema_2023_08_20 } from "./exclusion-groups/2023-08-20";
import { PluginExperimentSchema_2023_08_20 } from "./experiments/2023-08-20";
import { PluginCampaignSchema_2023_08_20 } from "./experiments/testGroups/testCampaign/2023-08-20";
import { PluginIntegrationSchema_2023_08_20 } from "./integrations/2023-08-20";
import { PluginOptionsSchema_2023_08_20 } from "./options/2023-08-20";
import { PluginRedirectSchema_2023_08_20 } from "./redirects/2023-08-20";
import { PluginWidgetSchema_2023_08_20 } from "./widgets/2023-08-20";

export * from "./exclusion-groups/2023-08-20";
export * from "./experiments/2023-08-20";
export * from "./options/2023-08-20";
export * from "./redirects/2023-08-20";
export * from "./widgets/2023-08-20";

type IOption = z.output<typeof PluginOptionsSchema_2023_08_20>;
type IOptionIn = z.input<typeof PluginOptionsSchema_2023_08_20>;

interface Option extends z.ZodType<IOption, IOptionIn> {}

type IExperiment = z.output<typeof PluginExperimentSchema_2023_08_20>;
type IExperimentIn = z.input<typeof PluginExperimentSchema_2023_08_20>;

interface Experiment extends z.ZodType<IExperiment, IExperimentIn> {}

type IRedirect = z.output<typeof PluginRedirectSchema_2023_08_20>;
type IRedirectIn = z.input<typeof PluginRedirectSchema_2023_08_20>;

interface Redirect extends z.ZodType<IRedirect, IRedirectIn> {}

export const PluginConfigSchema_2023_08_20 = z.object({
  storeName: z.string(),
  orgId: z.uuid(),
  buildId: z.number(),
  version: z.literal("2023-08-20"),
  experiments: (PluginExperimentSchema_2023_08_20 as Experiment)
    .array()
    .default([]),
  redirects: (PluginRedirectSchema_2023_08_20 as Redirect).array().default([]),
  campaigns: PluginCampaignSchema_2023_08_20.array().default([]),
  exclusionGroups: PluginExclusionGroupSchema_2023_08_20.array().default([]),
  widgets: PluginWidgetSchema_2023_08_20.array().default([]),
  integrations: PluginIntegrationSchema_2023_08_20.array().default([]),
  options: PluginOptionsSchema_2023_08_20 as Option,
  builtBy: PluginBuiltBySchema_2024_05_05.nullish(),
});

export type PluginConfigType_2023_08_20 = z.infer<
  typeof PluginConfigSchema_2023_08_20
>;
